import React from "react";
import {
  ButtonAddHLPure,
  DialogContractor,
  FilterHLPure,
  HeaderHLPure,
  PromotionalFooterPure,
  SimpleLoading,
} from "../../pures";
import "./repse-status-by-company.css";
import { useState } from "react";
import RepseStatusByCompanyCompanyView from "./repse-status-by-company-company.view";
import RepseStatusByCompanyContractorsView from "./repse-status-by-company-contractors.view";
import RepseStatusByCompanyDocumentsView from "./repse-status-by-company-documents.view";
import { Container, Grid } from "@material-ui/core";
import RepseStatusByDocumentsView from "./repse-status-by-documents.view";
import { ContractRequestService } from "../../../services";
import {
  DialogSystemGLPure,
} from "../../pures";
import { NIL } from "uuid";

function RepseStatusByCompanyView(props) {

  let {
    email,
    token,
    selectedCompany
  } = props

  const url = process.env.REACT_APP_MIFIRMA_API;
  const contractRequest = new ContractRequestService(url);

  const today = new Date();
  let limitMaxDate = new Date();
  limitMaxDate.setDate(limitMaxDate.getDate() + 61);

  const [showDialog, setShowDialog] = useState(false);
  const [newContractorName, setNewContractorName] = useState("");
  const [newContractorEmail, setNewContractorEmail] = useState("");
  const [itselfRegister, setItselfRegister] = useState(false);
  const [newContractLimitDate, setNewContractLimitDate] = useState(today);
  const [toggleErrorInDate, setToggleErrorInDate] = useState(false);
  const [newContractorNotes, setNewContractorNotes] = useState("");
  const [myselfRegisterState, setMyselfRegister] = useState(false);
  const [errorInDate, setErrorInDate] = useState(false);
  const [errorInEmail, setErrorInEmail] = useState(false);
  const [loadingRequesting, setShowLoadingRequesting] = useState(false);
  const [completedRequesting, setShowCompletedRequesting] = useState(false);
  const [errorRequesting, setShowErrorRequesting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [contractorPersonType, seContractorPersonType] = useState(9)

  const contractorsOptionType = [
    {
      value: 7,
      name: "Contratante Persona Física"
    },
    {
      value: 8,
      name: "Contratante Persona Moral"
    }
  ]

  const title = `Estado REPSE por Empresa${props.selectedCompany ? `, ${props.selectedCompany.name}` : ""
    }`;

  const onFilterChange = (event) => {
    const selectedOption = event.target.value;
    props.onYearFilterChange(selectedOption);
  };

  const handleChangeContractrorEmail = (e) => {
    setNewContractorEmail(e.target.value);
  };

  const handleItselfRegister = (e) => {
    setItselfRegister(e.target.checked);
    if (e.target.checked) {
      setNewContractorEmail(email);
    } else {
      setNewContractorEmail("");
    }
  };


  const handleChangeLimitDate = (e) => {
    let todayDate = new Date();
    let eventDate = new Date(e.target.value);

    eventDate.setHours(0, 0, 0, 0);
    todayDate.setHours(0, 0, 0, 0);

    if (
      eventDate < todayDate ||
      eventDate > limitMaxDate ||
      eventDate === null
    ) {
      setToggleErrorInDate(true);
      setNewContractLimitDate(today);
    } else if (eventDate >= todayDate || eventDate <= limitMaxDate) {
      setToggleErrorInDate(false);
      setNewContractLimitDate(e.target.value);
    }
  };

  const handleChangeContractrorNotes = (e) => {
    setNewContractorNotes(e.target.value);
  };

  const createContractor = async () => {
    let emailRegex =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    try {
      if (newContractorEmail.match(emailRegex)) {
        const body = {
          email: newContractorEmail,
          emailCreator: email,
          name: newContractorName,
          limitDate: newContractLimitDate,
          notes: newContractorNotes,
          isRepse: true,
          onlyCreateContractor: true,
          companyId: selectedCompany.id,
          classifierId: 2,
          questionnaireId: NIL,
          contractorPersonType
        };
        setShowDialog(false);
        setShowLoadingRequesting(true);
        let response = await contractRequest.createContractor(body, token);
        if (response.data.statusCode === 200) {
          setShowLoadingRequesting(false);
          setShowCompletedRequesting(true);

          setTimeout(() => {
            setShowCompletedRequesting(false);
          }, 3000);
        } else if (response.data.statusCode === -2) {
          setErrorMessage(
            "El correo que intentas registrar para el proveedor ya ha sido utilizado anteriormente, por favor utilice otro correo. "
          );
          setShowLoadingRequesting(false);
          setShowErrorRequesting(true);
          setTimeout(() => {
            setShowErrorRequesting(false);
          }, 3000);
        } else {
          setShowLoadingRequesting(false);
          setShowErrorRequesting(true);
          setTimeout(() => {
            setShowErrorRequesting(false);
          }, 3000);
        }
      } else {
        setErrorInEmail(true);
        setTimeout(() => {
          setErrorInEmail(false);
        }, 3000);
      }
    } catch (e) {
      setShowLoadingRequesting(false);
      setShowErrorRequesting(true);
      setTimeout(() => {
        setShowErrorRequesting(false);
      }, 3000);
    }
  };



  const ReturnView = () => {
    if (props.error != "") {
      return <p>{props.error}</p>;
    } else if (props.selectedCompany) {
      if (props.selectedContractor) {
        if (props.monthSelected) {
          return (
            <RepseStatusByDocumentsView month={props.month} monthNumber={props.monthNumber} onMonthSelected={props.onMonthSelected} selectedMonth={props.selectedMonth} yearShown={props.selectedYear} selectedContractor={props.selectedContractor} />
          );
        } else {
          return (
            <RepseStatusByCompanyDocumentsView
              documents={props.documents}
              onMonthSelected={props.onMonthSelected}
              getColorByStatus={props.getColorByDocumentStatus}
              onBack={props.onBackDocumentScreen}
              yearShown={props.selectedYear}
              getDocumentUrl={props.getDocumentUrl}
            />
          );
        }
      } else {
        return (
          <RepseStatusByCompanyContractorsView
            contractors={props.contractors}
            onContractorSelected={props.onContractorSelected}
            getColorByStatus={props.getColorByContractorStatus}
            onBack={props.onBackContractorScreen}
            yearShown={props.selectedYear}
          />
        );
      }
    } else {
      return (
        <RepseStatusByCompanyCompanyView
          companies={props.companies}
          onCompanySelected={props.onCompanySelected}
          getColorByStatus={props.getColorByCompanyStatus}
          yearShown={props.selectedYear}
        />
      );
    }
  };

  return (
    <>
      <div className="standard-wrapper">
        <Container>
          <HeaderHLPure title={title} />
          {props.loading ? (
            <SimpleLoading />
          ) : (
            <div>
              <Grid
                container
                xs={12}
                lg={12}
                md={12}
                sm={12}
                es={12}
                className="repseStatusByCompany-actionsContainer"
              >
                {errorRequesting ? (
                  <DialogSystemGLPure
                    showErrorRequesting={errorRequesting}
                    message={errorMessage}
                    toggleErrorRequesting={() => setShowErrorRequesting(false)}
                  />
                ) : null}
                {loadingRequesting ? (
                  <DialogSystemGLPure
                    showLoadingRequesting={loadingRequesting}
                    toggleLoadingRequesting={() => setShowLoadingRequesting(false)}
                  />
                ) : null}
                {completedRequesting ? (
                  <DialogSystemGLPure
                    showCompletedRequesting={completedRequesting}
                    toggleCompletedRequesting={() => setShowCompletedRequesting(false)}
                  />
                ) : null}
                {props.selectedCompany && !props.selectedContractor && (
                  <ButtonAddHLPure
                    nameBtn={"Agregar proveedor"}
                    iconAdd={true}
                    onClickBtn={() => setShowDialog(true)}
                  />
                )}

                {props.selectedCompany && props.selectedContractor && (
                  <h2>{props.selectedContractor.name}</h2>
                )}

                <div className="justify-right">
                  <FilterHLPure
                    options={props.yearFilterOptions}
                    optionsValue={props.selectedYear.toString()}
                    nameOption="year"
                    valueItem="yearValue"
                    onFilterChange={onFilterChange}
                  />
                </div>
              </Grid>

              {/* {props.error != "" ? (
                <p>{props.error}</p>
              ) : props.selectedCompany ? (
                props.selectedContractor ? (
                  <RepseStatusByCompanyDocumentsView
                    documents={props.documents}
                    onMonthSelected={props.onMonthSelected}
                    getColorByStatus={props.getColorByDocumentStatus}
                    onBack={props.onBackDocumentScreen}
                  />
                ) : (
                  <RepseStatusByCompanyContractorsView
                    contractors={props.contractors}
                    onContractorSelected={props.onContractorSelected}
                    getColorByStatus={props.getColorByContractorStatus}
                    onBack={props.onBackContractorScreen}
                  />
                )
              ) : props.monthSelected ? (
                <RepseStatusByDocumentsView
                  selectedMonth={props.selectedMonth}
                />
              ) : (
                <RepseStatusByCompanyCompanyView
                  companies={props.companies}
                  onCompanySelected={props.onCompanySelected}
                  getColorByStatus={props.getColorByCompanyStatus}
                />
              )} */}
              <ReturnView />
            </div>
          )}
          <Grid item xs={12} lg={12} md={12} sm={12} style={{ marginTop: 30 }}>
            <PromotionalFooterPure />
          </Grid>
        </Container>
      </div>
      {showDialog &&
        <DialogContractor
          //Nombre
          labelNameInput={"Nombre o razón social"}
          stateNameContractor={newContractorName}
          onChangeNameContractor={(e) => setNewContractorName(e.target.value)}
          //Correo
          labelEmailInput={"Correo del proveedor REPSE"}
          stateEmailContractor={newContractorEmail}
          onChangeEmailContractor={handleChangeContractrorEmail}
          myselfRegisterState={itselfRegister}
          onChangeMyselfRegister={(e) => handleItselfRegister(e)}
          //Fecha
          labelDataPicker={"Fecha limite de alta"}
          stateDate={newContractLimitDate}
          limitDate={today}
          limitMaxDate={limitMaxDate}
          onChangeDateContractor={handleChangeLimitDate}
          onErrorDateState={toggleErrorInDate}
          //Notas
          stateNotesContractor={newContractorNotes}
          onChangeNotesContractor={handleChangeContractrorNotes}
          //Dropdown
          personTypeLabel={"Tipo de persona"}
          onTypePersonChange={(e) => seContractorPersonType(Number(e.target.value))}
          contractorsTypeOptions={contractorsOptionType}
          valueOptionDropdown={"value"}
          nameOptionDropdown={"name"}
          //Botones y Dialog
          cancelName={"Cancelar"}
          submitName={"Guardar"}
          titleDialog={"Crear un nuevo proveedor REPSE"}
          cancel={() => setShowDialog(false)}
          handleSubmit={() => createContractor()}
        />
      }
    </>
  );
}

export default RepseStatusByCompanyView;
